import { render, staticRenderFns } from "./GalleryImage.vue?vue&type=template&id=9231ce52&scoped=true&"
import script from "./GalleryImage.vue?vue&type=script&lang=js&"
export * from "./GalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryImage.vue?vue&type=style&index=0&id=9231ce52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9231ce52",
  null
  
)

export default component.exports